import loadable from '@loadable/component';
import * as React from 'react';

import LoadingPage from '../../../components/LoadingPage';
import Page from '../../../components/Page';
import { mpTrackingScreens } from '../../../config/screens';

const LoadableSubscriptionSuccess = loadable(() => import('./SuccessDownloadApp'), {
    fallback: <LoadingPage isDark />,
});

class LazyLoadSubscriptionSuccess extends React.Component {
    render() {
        return (
            <Page noCrawl title="Subscription Successful - Download the Noa App" trackingScreen={mpTrackingScreens.subscriptionSuccessDownloadApp}>
                <LoadableSubscriptionSuccess mode="subscription" />
            </Page>
        );
    }
}

export default LazyLoadSubscriptionSuccess;
